import { render, staticRenderFns } from "./ComplaintChannel.vue?vue&type=template&id=2817892d&scoped=true"
import script from "./ComplaintChannel.vue?vue&type=script&lang=js"
export * from "./ComplaintChannel.vue?vue&type=script&lang=js"
import style0 from "./ComplaintChannel.vue?vue&type=style&index=0&id=2817892d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817892d",
  null
  
)

export default component.exports